<template>
  <div class="page-content">
    <el-button class="egl-btn-white cancel" @click="$router.back()">{{$locale("global.backTo")}}</el-button>
    <div class="schedule-detail" style="margin-bottom: 40px;">
      <el-breadcrumb separator="/" class="egl-breadcrumb">
        <el-breadcrumb-item :to="{ path: '/concession' }">{{ $locale("sideMenu.shop.concession") }}</el-breadcrumb-item>
        <el-breadcrumb-item>アイテム作成</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-table
      class="egl-table concessionAdd"
      :data="tableData"
      :border="true"
    >
      <el-table-column align="center" width="400">
        <template slot="header">
          <p>{{ $locale('global.image') }}</p>
          <p>{{ $locale('shop.upload.tips') }}</p>
        </template>
        <template slot-scope="scope">
          <el-row>
            <el-col>
              <UploadContainer
                :itemWidth="140"
                :itemHeight="161"
                :imageList="[scope.row.imageUrl]"
                @onSuccess="({response}) => uploadSuccess(response, scope.$index)"
                @onDelete="deleteImg(scope.$index)"
              ></UploadContainer>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column :label="$locale('global.basicInfo')" align="center">
        <el-table-column label-class-name="none">
          <template slot-scope="scope">
            <div class="basicInfo-container">
              <div class="input-item">
                <span>{{ $locale("shop.barcode") }}</span>
                <el-input v-model="scope.row.barCode" maxlength="255" />
              </div>
              <div class="input-item" style="margin-top: 15px;">
                <span>{{ $locale("global.productCode") }}</span>
                <el-input v-model="scope.row.productCode" maxlength="255" />
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label-class-name="none">
          <template slot-scope="scope">
            <div class="basicInfo-container">
              <div class="input-item">
                <span>{{ $locale('global.name') + '*' }}</span>
                <el-input v-model="scope.row.name" maxlength="255" />
              </div>
              <div class="input-item" style="margin-top: 15px;">
                <span>{{ $locale('global.price_taxIncluded') + "*" }}</span>
                <el-input
                  v-model="scope.row.price"
                  @input.native="getNotTaxPrice(scope.row)"
                  maxlength="20"
                >
                  <template slot="prepend">¥</template>
                </el-input>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label-class-name="none">
          <template slot-scope="scope">
            <div class="basicInfo-container">
              <div class="input-item">
                <span>{{ $locale('shop.taxDisplay') + '*' }}</span>
                <TaxSelect v-model="scope.row.taxRate" :isSaleOption="false" @change="getNotTaxPrice(scope.row)" />
              </div>
              <div class="input-item" style="margin-top: 15px;">
                <span>{{ $locale('shop.amount_excludingTax') + '*' }}</span>
                <el-input v-model="scope.row.notTaxPrice" disabled maxlength="20">
                  <template slot="prepend">¥</template>
                </el-input>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label-class-name="none">
          <template slot-scope="scope">
            <div class="basicInfo-container">
              <div class="input-item">
                <span>{{ $locale('shop.purchasePrice_taxIncluded') }}</span>
                <el-input v-model="scope.row.productCost" maxlength="20" @input.native="getNotTaxPrice" @change="value => priceFormatter(value, scope.row, 'productCost')"/>
              </div>
              <div class="input-item" style="margin-top: 15px;">
                <span>{{ $locale('shop.purchasePriceUnit_taxIncluded') }}</span>
                <el-input v-model="scope.row.priceWithoutTax" @input.native="getTaxedPrice(scope.row)" @change="value => priceFormatter(value, scope.row, 'priceWithoutTax')" />
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label-class-name="none">
          <template slot-scope="scope">
            <div class="basicInfo-container">
              <div class="input-item">
                <span>{{ $locale('shop.consumptionTax_purchaseCost') }}</span>
                <TaxSelect v-model="scope.row.taxRateCost" :isSaleOption='true' @change="getNotTaxPrice(scope.row)" />
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label-class-name="none">
          <template slot-scope="scope">
            <div class="basicInfo-container">
              <div class="input-item">
                <span>{{ $locale('shop.stockLocation')}}</span>
                <el-input v-model="scope.row.stockPlace" maxlength="255" />
              </div>
              <div class="input-item" style="margin-top: 15px;">
                <span>{{ $locale('global.unit') }}</span>
                <el-input v-model="scope.row.unit" maxlength="255" />
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        :label="$locale('global.control')"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <div class="handle">
            <a @click="openDetail(scope.$index)">{{ $locale("schedule.table.detailSetting") }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="resetRow(scope.$index)">{{ $locale("global.reset") }}</a>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="margin-top: 10px;">
      <el-col :span="24">
        <el-button @click="addRowHandler" style="float: right; margin-left: 33px;" class="egl-btn-yellow addRow">
          {{$locale("shop.concessionAdd.addRow")}}
          <img src="../../assets/img/addRow.svg"/>
        </el-button>
        <el-button @click="allResetHandler" style="float: right" class="egl-btn-white">{{$locale("schedule.table.allReset")}}</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20" type="flex" justify="center">
      <el-col :span="4">
        <el-button class="egl-btn-white" @click="$router.back(-1)" style="min-width: 200px;">{{$locale("global.cancel")}}</el-button>
      </el-col>
      <el-col :span="4">
        <el-button class="egl-btn-yellow" @click="save_fn" style="min-width: 200px;">{{$locale("global.confirm")}}</el-button>
      </el-col>
    </el-row>
    <!-- Detail Dialog -->
    <el-dialog
      :visible.sync="isDetailOpen"
      width="1200px"
      :show-close="true"
      class="egl-dialog-elm"
      :title="$locale('shop.concessionAdd.detail') + (tableData.length > 0 && tableData[curIdx].name ? ` : ${tableData[curIdx].name}` : '')"
      :close-on-click-modal="false"
    >
      <el-form :model=form ref="detailForm" :rules="formRules" label-position="top">
        <div class="form-module-tit">{{ $locale("shop.concessionAdd.detail.ticketSalesSetting") }}</div>
        <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$locale('shop.concessionAdd.detail.ticketSalesSetting.salesDepartment')" prop="salesDepartment">
                <el-select v-model="form.salesDepartment"></el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('global.type')" prop="productType">
                <el-select v-model="form.productType" disabled>
                  <el-option
                    v-for="item in productTypeOption"
                    :label="saleFormMap[item]"
                    :value="item"
                    :key="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('shop.supplier')" prop="clientId">
                <RemoteSelectV2
                  ref="selectV2Client"
                  type="client"
                  :list="comClientList"
                  v-model="form.clientId"
                  :isMultiple="false"
                  :formValue.sync="form.clientId"
                  :fields="['id', 'name']"
                  @setList="arr => comClientList = arr"
                />
              </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="8">
              <div class="form-module-tit">{{ $locale("shop.couponSetting") }}</div>
              <el-form-item :label="$locale('shop.unavailableCoupon')" prop="unavailableCoupons">
                <RemoteSelectV2
                  ref="selectV2Coupon"
                  type="coupon"
                  :list="comCouponList"
                  v-model="form.unavailableCoupons"
                  :formValue.sync="form.unavailableCoupons"
                  :fields="['id', 'name']"
                  @setList="arr => comCouponList = arr"
                  @selectAll="arr => form.unavailableCoupons = arr"
                  :isSelectAllFunc="true"
                  :isCollapse="true"
                />
              </el-form-item>
            </el-col>
            <el-col class="channel-inventory" :span="16" v-if="(form.options.length === 1 && form.options[0].name != '') || form.options.length > 1">
              <div class="form-module-tit">{{ $locale("shop.contentsSetting") }}</div>
              <el-form-item :label="$locale('shop.optionalMaterial')">
                <div class="inventory-list" v-for="(optionItem, i) in form.options" :key="i">
                  <div class="inventory-name">{{optionItem.name}}</div>
                  <template v-for="(ingredient, j) in optionItem.ingredientIds">
                    <el-row style="margin-bottom: 10px;" :gutter="20" :key="optionItem.name + j" v-if="optionItem.name != ''">
                      <el-col :span="9">
                        <el-select
                          v-model="form.options[i].ingredientIds[j].ingredientId"
                          :placeholder="$locale('shop.plsSelectMaterial')"
                          @change="val => chooseIngredient(i, j, val)"
                        >
                          <el-option
                            v-for="item in ingredientList"
                            :label="item.name"
                            :value="item.id"
                            :key="item.id"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="5">
                        <el-input
                          v-model="form.options[i].ingredientIds[j].ingredientQty"
                          :placeholder="$locale('form.plsEnterNum')"
                          @change="value => priceFormatterForIngredient(value, i, j, true)"
                          maxlength="10"
                        ></el-input>
                      </el-col>
                      <el-col :span="4" class="unit" v-if="form.options[i].ingredientIds[j].ingredientId">
                        <template v-for="item in ingredientList">
                          <span :key="item.id" v-if="item.id == form.options[i].ingredientIds[j].ingredientId">{{ item.unit }}</span>
                        </template>
                      </el-col>
                      <el-col
                        :span="6"
                        class="handle-btn"
                        v-if="action != 'detail'"
                      >
                        <i
                          class="el-icon-remove-outline"
                          v-if="form.options[i].ingredientIds.length > 1"
                          @click="removeIngredient(i, j)"
                        ></i>
                        <i
                          class="el-icon-circle-plus-outline"
                          v-if="j == form.options[i].ingredientIds.length - 1"
                          @click="addIngredient(i)"
                        ></i>
                      </el-col>
                    </el-row>
                  </template>
                </div>
              </el-form-item>
            </el-col>
            <el-col class="channel-inventory" :span="16" v-else>
              <div class="form-module-tit">{{ $locale("shop.materialSetting") }}</div>
              <el-form-item :label="$locale('shop.optionalMaterial')">
                <div class="inventory-list">
                  <div class="inventory-name">{{tableData[curIdx].name}}</div>
                  <template v-for="(ingredient, j) in form.ingredientIds">
                    <el-row :gutter="20" :key="j" class="ingredientItem">
                      <el-col :span="9">
                        <el-select
                          v-model="form.ingredientIds[j].ingredientId"
                          :placeholder="$locale('shop.plsSelectMaterial')"
                          @change="val => chooseIngredientIds(j, val)"
                          :filterable="true"
                        >
                          <el-option
                            v-for="item in ingredientList"
                            :label="item.name"
                            :value="item.id"
                            :key="item.id"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="5">
                        <el-input
                          @change="value => priceFormatterForIngredient(value, null, j, false)"
                          v-model="form.ingredientIds[j].ingredientQty"
                          :placeholder="$locale('form.plsEnterNum')"
                          maxlength="10"
                        ></el-input>
                      </el-col>
                      <el-col :span="4" class="unit" v-if="form.ingredientIds[j].ingredientId">
                        <template v-for="item in ingredientList">
                          <span :key="item.id" v-if="item.id == form.ingredientIds[j].ingredientId">{{ item.unit }}</span>
                        </template>
                      </el-col>
                      <el-col
                        :span="6"
                        class="handle-btn"
                        v-if="action != 'detail'"
                      >
                        <i
                          class="el-icon-remove-outline"
                          v-if="form.ingredientIds.length > 1"
                          @click="removeIngredientIds(j)"
                        ></i>
                        <i
                          class="el-icon-circle-plus-outline"
                          v-if="j == form.ingredientIds.length - 1"
                          @click="addIngredientIds(j)"
                        ></i>
                      </el-col>
                    </el-row>
                  </template>
                </div>
              </el-form-item>
            </el-col>
        </el-row>
        <div class="form-module">
            <div class="form-module-tit">{{ $locale("shop.optionSetting") }}</div>
            <el-row>
              <el-col :span="6">
                <el-form-item label="オプションタイトル" prop="optionTitle">
                  <el-input v-model="form.optionTitle" />
                </el-form-item>
              </el-col>
            </el-row>
            <div class="clearfix dynamic-table">
              <div class="table-box">
                  <el-table :data="form.options" class="egl-table" border cell-class-name="dynamicTD">
                    <el-table-column :label="$locale('global.productCode')" align="center">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.productCode"
                          :placeholder="$locale('form.plsEnterProductCode')"
                          maxlength="255"
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$locale('global.name')" align="center">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.name"
                          :placeholder="$locale('form.plsEnterYourName')"
                          maxlength="255"
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$locale('shop.stockLocation')" align="center">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.stockPlace"
                          :placeholder="$locale('shop.plsEnterStockLocation')"
                          maxlength="255"
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$locale('shop.barcode')" align="center">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.barCode"
                          :placeholder="$locale('shop.plsEnterBarcode')"
                          maxlength="255"
                        ></el-input>
                      </template>
                    </el-table-column>
                  </el-table>
              </div>
              <div class="table-handle-btn" v-if="this.action != 'detail'">
                <div class="btn-item" v-for="(obj, i) in form.options" :key="i">
                    <i
                      class="el-icon-remove-outline"
                      v-if="form.options.length > 1"
                      @click="removeTableRow(i)"
                    ></i>
                    <i
                      class="el-icon-circle-plus-outline"
                      v-if="i == form.options.length - 1"
                      @click="addTableRow"
                    ></i>
                </div>
              </div>
            </div>
        </div>
        <div class="form-module">
          <div class="form-module-tit">{{ $locale("global.dispRelatedSettings") }}</div>
          <el-row :gutter="20">
            <el-col :span="5">
              <el-form-item :label="$locale('global.hiddenSetting')" class="undisplay">
                <div class="undisplay-btn clearfix">
                  <el-button
                    v-for="btn in unDisplayBtn"
                    :key="btn.text"
                    :class="
                      form[btn.keyName] == true
                        ? 'egl-btn-white-gray-border'
                        : 'egl-btn-white'
                    "
                    @click="unDisplay_fn(btn.keyName)"
                    >{{ btn.text }}</el-button
                  >
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('global.btnBackgroundColor') + '（' + $locale('global.POS') + '）'" prop="bgColor">
                <ColorPicker v-model="form.bgColor" @change="clearFormValidate('bgColor')" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$locale('global.btnTextColor') + '（' + $locale('global.POS') + '）'" prop="fontColor">
              <ColorPicker v-model="form.fontColor" @change="clearFormValidate('fontColor')" />
            </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$locale('form.displayPOS')" prop="groupId" class="makeFull">
                <el-select
                  :placeholder="$locale('shop.plsSelectDepartment')"
                  v-model="form.groupId"
                >
                  <el-option
                    v-for="item in departmentOption"
                    :label="item.name"
                    :value="item.id"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 10236 reduction -->
            <el-col :span="6">
              <el-form-item :label="$locale('global.displayOrder') + '（' + $locale('global.POS') + '）'" prop="sort" class="makeFull">
                <el-input
                  v-model.number="form.sort"
                  :placeholder="$locale('form.plsEnterNumDispOrder_POS')"
                  maxlength="5"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$locale('form.displaySC')" prop="scGroupId" class="makeFull">
                <el-select
                  :placeholder="$locale('shop.plsSelectDepartment')"
                  v-model="form.scGroupId"
                >
                  <el-option
                    v-for="item in scDepartmentOption"
                    :label="item.name"
                    :value="item.id"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 10236 reduction -->
            <el-col :span="6">
              <el-form-item :label="$locale('global.displayOrder') + '（' + $locale('global.selfCashier') + '）'" prop="scSort" class="makeFull">
                <el-input
                  v-model.number="form.scSort"
                  :placeholder="$locale('form.plsEnterNumDispOrder_SC')"
                  maxlength="5"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$locale('global.status')" prop="publish" class="makeFull">
                <el-select v-model="form.publish">
                  <el-option
                    v-for="item in publishOption"
                    :label="item.text"
                    :value="item.type"
                    :key="item.type"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
                  <el-form-item :label="$locale('shop.kiosk.groups')" class="makeFull">
                    <el-select v-model="form.cinemaDailySelective" >
                      <el-option v-for="item in cinemaDailys"
                        :label="item.name"
                        :value="item.id"
                        :key="item.id" />
                    </el-select>
                  </el-form-item>
            </el-col>
            <el-col :span="8">
                  <el-form-item :label="$locale('bookKeeping.journal.dept')+' ('+$locale('setting.pay.accgroup')+')'" class="makeFull" prop="journalType">
                    <el-select v-model="form.journalType">
                      <el-option v-for="item in tradeGroupList"
                        :label="item.name"
                        :key="item.id"
                        :value="item.id"
                      />
                    </el-select>
                  </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$locale('rules.alertMessage')" style="width: 100%;">
                <el-row
                  :gutter="20"
                  class="message"
                  v-for="(item, idx) in form.customizeMsg"
                  :key="idx"
                >
                  <el-col :span="8">
                    <el-select v-model="item.deviceType">
                      <el-option
                        v-for="platfom in platforms"
                        :key="platfom.value"
                        :label="platfom.label" 
                        :value="platfom.value"
                        :disabled="isPlatformDisabled(platfom.value, idx)"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="8">
                    <el-input v-model="item.message" :placeholder="$locale('form.plsEnterMsg')" />
                  </el-col>
                  <el-col :span="8">
                    <el-button class="decrease" @click="decreaseMessage(idx)" v-if="form.customizeMsg.length > 1">
                      <i class="el-icon-minus"></i>
                    </el-button>
                    <el-button class="increase" @click="increaseMessage" v-if="showBtn('increase', idx)" >
                      <i class="el-icon-plus"></i>
                    </el-button>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 10236 reduction -->
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$locale('shop.description')" prop="description">
                <el-input
                  v-model="form.description"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$locale('shop.recommend')">
                <el-checkbox-group
                  v-model="checkboxGroup.sc"
                >
                  <el-checkbox label="recommend">{{ $locale("shop.recommend.sc") }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="this.action != 'detail'">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-button class="egl-btn-white" @click="colse_fn">{{$locale("global.cancel")}}</el-button>
            <el-button class="egl-btn-yellow" @click="saveDetail_fn">{{$locale("global.confirm")}}</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import UploadContainer from "@/components/common/UploadForConcession";
import TaxSelect from "@/components/common/TaxSelect";
import { taxOff, taxOffDec, taxAddDec } from "@/utils/math.js";
import { decimal2 } from "@/utils/utils";
import { saleFormMap, saleForm, kioskOpts, kioskMaps } from "@/utils/common.js";
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";
import { getClientListService } from "@/helpers/service/api/common";
import { getCouponTypeListForSelect } from "@/helpers/service/api/coupon";
import { getIngredientList } from "@/helpers/service/api/ingredient.js";
import ColorPicker from "@/components/common/ColorPicker";
import { getDepartment, createConcessionForNew } from "@/helpers/service/api/concession.js";
import { getListService } from "@/helpers/service/api/tradeGroup";
import countDownAlert from "@/utils/countDownAlert";
import { getCinemaDailyListService } from "@/helpers/service/api/theaterDailyShow.js";
import { getCinemaDailyIdForName } from "@/utils/common";

export default {
  data() {
    return {
      action: "create",
      roundSetting: window.localStorage.getItem("round"),
      tableData: [],
      isDetailOpen: false,
      curIdx: 0,
      checkboxGroup: {
        sc: false,
      },
      platforms: [
        {
          label: this.$locale("global.POS"),
          value: "POS",
        },
        {
          label: this.$locale("global.selfCashier"),
          value: "SELFCASHIER",
        },
      ],
      form: {
        cinemaId: window.localStorage.getItem("cinemaId"),
        productType: "SALES_ITEM",
        clientId: "",
        unavailableCoupons: [],
        ingredientIds: [ {
          ingredientId: "",
          ingredientName: "",
          ingredientQty: 0
        } ],
        options: [ {
          barCode: "",
          ingredientIds: [ {
            ingredientId: "",
            ingredientName: "",
            ingredientQty: 0
          } ],
          inventory: 0,
          name: "",
          productCode: "",
          stockPlace: ""
        } ],
        displayPos: true,
        displaySelfCashier: true,
        bgColor: "#FFFFFF",
        fontColor: "#000000",
        groupId: "",
        sort: "",
        scGroupId: "",
        scSort: "",
        publish: "RELEASE",
        cinemaDailySelective: "",
        journalType: "",
        description: "",
        optionTitle: "種類",
        customizeMsg: [
          {
            deviceType: "",
            message: "",
          }
        ],
      },
      formRules: {},
      productTypeOption: saleForm,
      saleFormMap : saleFormMap,
      comClientList: [],
      comCouponList: [],
      ingredientList: [],
      unDisplayBtn: [
        {
          text: this.$locale("global.POS"),
          keyName: "displayPos"
        },
        {
          text: this.$locale("global.selfCashier"),
          keyName: "displaySelfCashier"
        }
      ],
      departmentOption: [],
      scDepartmentOption: [],
      publishOption: [
        {
          type: "RELEASE",
          text: this.$locale("global.sale"),
        },
        {
          type: "RESERVE",
          text: this.$locale("global.stopSelling"),
        }
      ],
      kioskOpts,
      kioskMaps,
      tradeGroupList: [],
      cinemaDailys: [],
    };
  },
  mounted() {
    for (let i = 0; i < 5; i++) {
      this.tableData.push({
        imageUrl: "",
        barCode: "",
        productCode: "",
        name: "",
        price: 0,
        taxRate: 0.1,
        notTaxPrice: 0,
        productCost: 0,
        priceWithoutTax: 0,
        taxRateCost: "percentTen",
        stockPlace: "",
        unit: "",
      });
    }
    // get client list
    getClientListService({
      ...this.form.clientId ? { ids: this.form.clientId } : {},
      page: 0,
      pageSize: this.form.clientId.length > 0 ? 99999 : 20,
      field: ["id", "name"]
    }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.comClientList = res.data.data;
      }
    });
    // get coupon list
    getCouponTypeListForSelect({
      cinemaId: window.localStorage.getItem("cinemaId"),
      ...this.form.unavailableCoupons.length > 0 ? { ids: this.form.unavailableCoupons } : {},
      page: 0,
      pageSize: this.form.unavailableCoupons.length > 0 ? 99999 : 20,
      field: ["id", "name"]
    }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.comCouponList = res.data.data;
      }
    });
    // get ingredient list
    getIngredientList({
      cinemaId: window.localStorage.getItem("cinemaId"),
      page: 0,
      pageSize: 99999
    }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.ingredientList = res.data.data;
      }
    });
    // get department list
    getDepartment({
      cinemaId: window.localStorage.getItem("cinemaId"),
      page: 0,
      pageSize: 99999,
      type: "concession"
    }).then(res => {
      if (res.data && res.data.length > 0) {
        this.departmentOption = res.data;
      }
    });
    getDepartment({
      cinemaId: window.localStorage.getItem("cinemaId"),
      page: 0,
      pageSize: 99999,
      type: "concessionCsc"
    }).then(res => {
      if (res.data && res.data.length > 0) {
        this.scDepartmentOption = res.data;
      }
    });
    // get tradeGroup list
    getListService({
      brandId: window.localStorage.getItem("brandId")
    }).then(res => {
      if (res.data && res.data.length > 0) {
        this.tradeGroupList = res.data;
      }
    });
    // get cinemaDaily list
    getCinemaDailyListService({ cinemaId: window.localStorage.getItem("cinemaId") }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.cinemaDailys = res.data.data;
        this.form.cinemaDailySelective = getCinemaDailyIdForName(res.data.data);
      }
    });
  },
  methods: {
    openDetail(index) {
      this.curIdx = index;
      this.isDetailOpen = true;
    },
    uploadSuccess(res, index) {
      this.tableData[index]["imageUrl"] = res.data;
    },
    deleteImg(index) {
      this.tableData[index]["imageUrl"] = "";
    },
    getNotTaxPrice(obj) {
      let { price, productCost, taxRate, taxRateCost } = obj;
      let notTaxPrice = taxOff(price, taxRate, this.roundSetting);
      let ctaxrate = 0;
      if (taxRateCost === "percentTen") {
        ctaxrate = 0.1;
      } else if (taxRateCost === "percenteight") {
        ctaxrate = 0.08;
      } else {
        ctaxrate = 0;
      }

      let noTaxCost = taxOffDec(productCost, ctaxrate, this.roundSetting);
      obj.notTaxPrice = isNaN(notTaxPrice) ? 0 : notTaxPrice;
      obj.priceWithoutTax = isNaN(noTaxCost) ? 0 : noTaxCost;
    },
    getTaxedPrice(obj) {
      let { taxRateCost, priceWithoutTax } = obj;
      let ctaxrate = 0;
      if (taxRateCost === "percentTen") {
        ctaxrate = 0.08;
      } else if (taxRateCost === "percenteight") {
        ctaxrate = 0.08;
      } else {
        ctaxrate = 0;
      }

      let taxedCost = taxAddDec(priceWithoutTax, ctaxrate, this.roundSetting);
      obj.productCost = isNaN(taxedCost) ? 0 : taxedCost;
    },
    resetRow(index) {
      let _arr = this.$_.cloneDeep(this.tableData);
      _arr[index] = {
        imageUrl: "",
        barCode: "",
        productCode: "",
        name: "",
        price: 0,
        taxRate: 0.1,
        notTaxPrice: 0,
        productCost: 0,
        priceWithoutTax: 0,
        taxRateCost: "percentTen",
        stockPlace: "",
        unit: "",
      };
      this.tableData = _arr;
    },
    addRowHandler() {
      let _arr = this.$_.cloneDeep(this.tableData);
      console.log(_arr);
      _arr.push({
        imageUrl: "",
        barCode: "",
        productCode: "",
        name: "",
        price: 0,
        taxRate: 0.1,
        notTaxPrice: 0,
        productCost: 0,
        priceWithoutTax: 0,
        taxRateCost: "percentTen",
        stockPlace: "",
        unit: "",
      });
      this.tableData = _arr;
    },
    priceFormatter(value, obj, type) {
      obj[type] = Number(decimal2(value));
    },
    createHandler() {},
    allResetHandler() {
      let _arr = this.$_.cloneDeep(this.tableData);
      for (let i = 0; i < _arr.length; i++) {
        _arr[i] = {
          imageUrl: "",
          barCode: "",
          productCode: "",
          name: "",
          price: 0,
          taxRate: 0.1,
          notTaxPrice: 0,
          productCost: 0,
          priceWithoutTax: 0,
          taxRateCost: "percentTen",
          stockPlace: "",
          unit: "",
        };
      }
      this.tableData = _arr;
    },
    save_fn() {
      // 判断至少有一组数据填写完整
      const isPass = this.tableData.some(item =>
        item.name && item.price);
      if (!isPass) {
        this.$alert("please input name or price");
      } else {
        // 过滤没有填写完整的数据
        const _data = this.tableData.filter(item => item.name && item.price);
        const _arrs = _data.map(item => {
          const _info = item.cinemaId ? {
            ...item,
            customizeMsg: item.customizeMsg ? item.customizeMsg.filter(msg => msg.deviceType !== "" && msg.message !== "") : [],
          } : {
            ...item,
            ...this.form,
            customizeMsg: item.customizeMsg ? item.customizeMsg.filter(msg => msg.deviceType !== "" && msg.message !== "") : [],
            recommend: this.checkboxGroup.sc,
          };

          // 只保留填写了名称的オプション設定，并过滤没有选择材料的行
          const _options = (_info.options || [])
            .filter(option => option.name)
            .map(option => ({
              ...option,
              ingredientIds: (option.ingredientIds || []).filter(ingredient => ingredient.ingredientId),
            }));

          if (_options.length) {
            // 有オプション設定：只传 options 里的 ingredientIds
            delete _info.ingredientIds;
            _info.options = _options;
          } else {
            // 没有オプション設定：options 传空数组，只传外层 ingredientIds
            _info.options = [];
            _info.ingredientIds = (_info.ingredientIds || []).filter(ingredient => ingredient.ingredientId);
          }

          return { concessionTypeInfo: _info };
        });
        createConcessionForNew({
          concessionList: _arrs,
        }).then(res => {
          if (res.success) {
            this.allResetHandler();
            countDownAlert({
              content: this.$locale("global.createSuccessfully")
            });
          }
        });
      }
    },
    createOptionObj: () => {
      return {
        barCode: "",
        productCode: "",
        inventory: 0,
        stockPlace: "",
        name: "",
        ingredientIds: [
          {
            ingredientId: "",
            ingredientName: "",
            ingredientQty: 0
          }
        ],
      };
    },
    chooseIngredient(i, j, val) {
      let form = this.$_.cloneDeep(this.form);
      let text = "";

      for (let i = 0; i < this.ingredientList.length; i++) {
        if (this.ingredientList[i].id === val) {
          text = this.ingredientList[i].name;
          break;
        }
      }

      form.options[i].ingredientIds[j].ingredientName = text;

      this.form = form;
    },
    chooseIngredientIds(i, val) {
      let form = this.$_.cloneDeep(this.form);
      let text = "";


      for (let i = 0; i < this.ingredientList.length; i++) {
        if (this.ingredientList[i].id === val) {
          text = this.ingredientList[i].name;
          break;
        }
      }
      form.ingredientIds[i].ingredientName = text;

      this.form = form;
    },
    priceFormatterForIngredient(value, i, j, isHaveName) {
      if (isHaveName) {
        this.form.options[i].ingredientIds[j].ingredientQty = decimal2(value);
      } else {
        this.form.ingredientIds[j].ingredientQty = decimal2(value);
      }
    },
    removeIngredient(i, j) {
      let form = this.$_.cloneDeep(this.form);

      form.options[i].ingredientIds.splice(j, 1);

      this.form = form;
    },
    removeIngredientIds(i) {
      let form = this.$_.cloneDeep(this.form);

      form.ingredientIds.splice(i, 1);

      this.form = form;
    },
    addIngredient(i) {
      console.log("?????");
      let form = this.$_.cloneDeep(this.form);
      let ingredientLength = form.options[i].ingredientIds.length;

      if (
        form.options[i].ingredientIds[ingredientLength - 1].ingredientId !== ""
      ) {
        form.options[i].ingredientIds.push({
          ingredientId: "",
          ingredientName: "",
          ingredientQty: 0,
        });
      }

      this.form = form;
    },
    addIngredientIds() {
      let form = this.$_.cloneDeep(this.form);

      form.ingredientIds.push({
        ingredientId: "",
        ingredientName: "",
        ingredientQty: 0
      });

      this.form = form;
    },
    removeTableRow(index) {
      let formObj = this.$_.cloneDeep(this.form);
      formObj.options.splice(index, 1);

      this.form = formObj;
    },
    addTableRow() {
      let formObj = this.$_.cloneDeep(this.form);

      if (formObj.options[formObj.options.length - 1].name != "") {
        formObj.options.push(this.createOptionObj());

        this.form = formObj;
      }
    },
    unDisplay_fn(keyName) {
      let formObj = this.$_.cloneDeep(this.form);
      formObj[keyName] = !formObj[keyName];

      this.form = formObj;
    },
    clearFormValidate(fieldName) {
      if (fieldName) {
        this.$refs.detailForm.clearValidate(fieldName);
      } else {
        this.$refs.detailForm.clearValidate();
      }
    },
    colse_fn() {
      this.$refs.detailForm.resetFields();
      this.form.ingredientIds = [ {
        ingredientId: "",
        ingredientName: "",
        ingredientQty: 0
      } ];
      this.form.options = [ {
        barCode: "",
        ingredientIds: [ {
          ingredientId: "",
          ingredientName: "",
          ingredientQty: 0
        } ],
        inventory: 0,
        name: "",
        productCode: "",
        stockPlace: ""
      } ];
      this.checkboxGroup.sc = false;
      this.isDetailOpen = false;
    },
    saveDetail_fn() {
      let _obj = this.$_.cloneDeep(this.tableData[this.curIdx]);
      _obj = { ..._obj, ...this.form, recommend: this.checkboxGroup.sc };
      this.$set(this.tableData, this.curIdx, _obj);
      this.colse_fn();
    },
    increaseMessage() {
      if (this.form.customizeMsg.length >= this.platforms.length) { return; }
      this.form.customizeMsg.push({
        deviceType: "",
        message: "",
      });
    },
    decreaseMessage(idx) {
      this.form.customizeMsg.splice(idx, 1);
    },
    isPlatformDisabled(platformValue, currentIdx) {
      return this.form.customizeMsg.some((msg, idx) => idx !== currentIdx && msg.deviceType === platformValue);
    },
    showBtn(type, idx) {
      if (type === "increase") {
        if (this.form.customizeMsg.length >= this.platforms.length) {
          return false;
        }
        if (
          this.form.customizeMsg.length > 1 &&
          this.form.customizeMsg.length < 2 &&
          this.form.customizeMsg.length - 1 === idx
        ) {
          if (idx === 0) {
            return false;
          }
          return true;
        } else if (this.form.customizeMsg.length === 1) {
          return true;
        }
        return false;
      }
    },
  },
  components: {
    UploadContainer,
    TaxSelect,
    RemoteSelectV2,
    ColorPicker,
  }
};
</script>
<style lang="less" scoped>
  .page-content {
    position: relative;
    .cancel {
      min-width: 255px;
      position: absolute;
      top: 27px;
      right: 33px;
    }
    ::v-deep {
      .none {
        display: none;
      }
    }
    .input-item {
      width: 100%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .addRow {
      font-weight: 500;
      padding: 8px 22px;
      img {
        width: 22px;
        height: 22px;
        vertical-align: middle;
      }
    }
    .form-module {
      border-top: 1px dashed #ddd;
      padding: 25px 0;
    }
    .ingredientItem {
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .dynamic-table {
      box-sizing: border-box;
      display: inline-block;
      margin-top: 12px;
      padding-right: 100px;
      position: relative;
      width: 100%;
      ::v-deep {
        .dynamicTD {
          height: 50px;
          padding: 0;
          input {
            border: 0;
          }
        }
        th {
          background: #f5f5f5;
          color: #898989;
          font-size: 1.2rem;
          font-weight: 400;
        }
      }
      .table-box {
        display: inline-block;
        vertical-align: top;
        width: 100%;
      }
      .table-handle-btn {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 100px;
      .btn-item {
        height: 50px;
        line-height: 50px;
        i {
          cursor: pointer;
          font-size: 25px;
          margin-left: 20px;
          vertical-align: middle;
        }
      }
    }
    }
    .handle-btn i {
      cursor: pointer;
      font-size: 25px;
      margin-right: 20px;
      vertical-align: middle;
    }
    .message {
      margin-bottom: 22px;
      &:last-child {
        margin-bottom: 0;
      }
      .el-col:last-child {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .increase, .decrease {
        width: 40px;
        height: 40px;
        padding: 0;
        i {
          color: #C0C4CC;
        }
        &:hover,
        &:focus {
          border: 1px solid @primary-yellow;
          background-color: @pure-white;
          i {
            color: @primary-yellow;
          }
        }
      }
      .decrease {
        i {
          color: #C0C4CC;
        }
      }
    }
  }
</style>
